import { componentStyleWithExtend } from '@/styling/util/component-style.ts';
import type { AccordionDesignTokensComplete } from '../types/AccordionDesignTokensComplete';

export const accordionStyle: ReturnType<typeof componentStyleWithExtend<AccordionDesignTokensComplete>> =
    componentStyleWithExtend<AccordionDesignTokensComplete>({
        extend: {
            root: {
                panelBorderColorActive: '{primary.color}',
            },
        },
        style: {
            header: {
                color: '{color.text}',
                toggleIcon: {
                    color: '{primary.color}',
                    activeColor: '{primary.color}',
                },
            },
            panel: {
                borderWidth: '1px',
            },
        },
        css: ({ dt }) => `
        .p-accordionpanel.p-accordionpanel-active {
            border-color: ${String(dt('accordion.panel.border.color.active'))};
        }
    `,
    });
